module.exports = __webpack_public_path__ + "cachable/fonts/fa-regular-400.fb332093a8495d617b00df27293c0be6.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.woff
// module id = 1185
// module chunks = 0